import API from 'services/api';

export const printingAndLoggingOfInvoices = ({
  invoiceId,
  isPrintedAndLogged,
}: {
  invoiceId: string;
  isPrintedAndLogged: boolean;
}) => {
  return isPrintedAndLogged === false
    ? API.post(`/api/documents/invoices/${invoiceId}/print?option=ACCOUNTING&log=false`, null, {
        responseType: 'blob',
      })
    : API.post(`/api/documents/invoices/${invoiceId}/print?option=ACCOUNTING&log=true`, null, {
        responseType: 'blob',
      });
};
